import React, { FC } from "react"

type InlineCodeProps = {
  code?: string
  className?: string
}

const InlineCode: FC<InlineCodeProps> = ({
  code,
  className,
  children,
  ...rest
}) => {
  let classes = "inline-code"
  if (className) {
    classes = `${classes} ${className}`
  }
  return (
    <span className={classes} {...rest}>
      {code ? code : children}
    </span>
  )
}

export default InlineCode
